import { useTranslation } from '@/lib/i18n/react';

/** Parse trusted catalog placeholders before inserting escaped, direction-isolated values. */
export function ChatLiteralCopy({ copyKey, values }: { copyKey: string; values: Record<string, string> }) {
  const { t } = useTranslation('teamchat');
  return <>{t(copyKey).split(/(\{[a-zA-Z][a-zA-Z0-9_]*\})/g).map((part, index) => {
    const name = part.slice(1, -1);
    return /^\{[a-zA-Z][a-zA-Z0-9_]*\}$/.test(part) && Object.prototype.hasOwnProperty.call(values, name)
      ? <bdi dir="auto" key={index}>{values[name]}</bdi>
      : part;
  })}</>;
}
